<mat-form-field floatLabel="always">
   <mat-label> {{ customLabel ? customLabel : label ?? 'Date Range' }} </mat-label>
   <lcs-date-range-picker-input
      [formGroup]="form"
      [required]="requireInput"
      [initialContentFormValue]="contentFormValue"
      (contentFormValueChange)="onContentFormValueChange($event)"
   >
      <input lcsStartDate formControlName="startDate" />
      <input lcsEndDate formControlName="endDate" />
   </lcs-date-range-picker-input>
   <mat-error> Please select a date range </mat-error>
</mat-form-field>
